import React from "react";
import Contact from "./contact";
import Map from "./Map";
import Contactfooter from "./contactfooter";
import { Helmet } from "react-helmet";

const ContactUS = () => {
  return (
    <div>
       <Helmet>
        <title>Contact Us</title>
        <meta
          name="description"
          content="Krisoft provides top-notch Android development services, creating innovative and user-friendly mobile applications."
        />
        <meta
          name="keywords"
          content="Android development, mobile apps, Krisoft, app development, Android solutions"
        />
      </Helmet>
      <Contact />
      <Map />
      <Contactfooter />
    </div>
  );
};

export default ContactUS;
